import AccessDenied from "../../Pages/AccessDenied/AccessDenied";

const Protected = ({ permittedPages, pageContext, children }) => {
  const context = pageContext;
  var results = false;
  if (context != undefined) {
    context.Permissions?.map((permission) => {
      if (Object.keys(context.loggedInAs).length === 0) {
        context.loggedInAs = context.Roles[0];
      }
      if (permission.SystemName === permittedPages && permission.Role === context.loggedInAs.label) {
        results = true;
      }
    });
  }

  if (!results) {
    return <AccessDenied />;
  }
  return children;
};
export default Protected;
